export default {
    active: true,
    seed: 1,
    skyType: "gradient",
    skyColor: "#0d0d0d",
    horizonColor: "#404040",
    lighting: "distant",
    lightPosition: { x: 0, y: 1, z: -0.2 },
    fog: 0.81,
    flatShading: true,
    playArea: 1,
    ground: "hills",
    groundYScale: 4.81,
    groundTexture: "checkerboard",
    groundColor: "#252525",
    groundColor2: "#111111",
    dressing: "cubes",
    dressingAmount: 10,
    dressingColor: "#9f9f9f",
    dressingScale: 1.51,
    dressingVariance: { x: 5, y: 20, z: 5 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0,
    grid: "dots",
    gridColor: "#ccc",
    shadow: false,
};
